import { UserException } from '@/domain/user/exception/UserException'

export class MalformedEmailAddressException extends UserException {

}
